import {StyleSheet, Text, View, ViewStyle} from 'react-native';
import React from 'react';
import {
  Card,
  Colors,
  Sizes,
  TextStyles,
  BannerInformativeIcon,
  BannerSuccessIcon,
  BannerWarningIcon,
  BannerDangerIcon,
} from '../index';
import {ComponentProps} from './ComponentProps';

export type BannerSize = 's' | 'm';

interface BannerProps extends ComponentProps {
  title?: string;
  body?: string;
  sizeVariant?: BannerSize;
}

export const BannerNeutralLighter = (props: BannerProps) => {
  return (
    <Banner
      {...{
        ...props,
        backgroundColor: Colors.brandWhite,
        borderColor: Colors.neutralLighter,
      }}
    />
  );
};

export const BannerInformative = (props: BannerProps) => {
  return (
    <Banner
      {...{
        ...props,
        backgroundColor: Colors.informativeBannerBackground,
        borderColor: Colors.informativeBannerBorder,
        icon: <BannerInformativeIcon />,
      }}
    />
  );
};

export const BannerSuccess = (props: BannerProps) => {
  return (
    <Banner
      {...{
        ...props,
        backgroundColor: Colors.successBannerBackground,
        borderColor: Colors.successBannerBorder,
        icon: <BannerSuccessIcon />,
      }}
    />
  );
};

export const BannerWarning = (props: BannerProps) => {
  return (
    <Banner
      {...{
        ...props,
        backgroundColor: Colors.warningBannerBackground,
        borderColor: Colors.warningBannerBorder,
        icon: <BannerWarningIcon />,
      }}
    />
  );
};

export const BannerDanger = (props: BannerProps) => {
  return (
    <Banner
      {...{
        ...props,
        backgroundColor: Colors.dangerBannerBackground,
        borderColor: Colors.dangerBannerBorder,
        icon: <BannerDangerIcon />,
      }}
    />
  );
};

interface BannerComponentProps extends BannerProps {
  borderColor: string;
  backgroundColor: string;
  icon?: JSX.Element;
}

const Banner = (props: BannerComponentProps) => {
  const size = props.sizeVariant ?? 'm';
  const titleBottomMargin = props.title && props.body ? Sizes.xs : 0;
  let contentStyle: ViewStyle[] = [styles.content];
  let titleStyle = [
    TextStyles.textMediumM,
    {
      marginBottom: titleBottomMargin,
      color: Colors.neutralDarker,
    },
  ];
  let descriptionStyle = [
    TextStyles.textMediumS,
    {
      color: Colors.neutralDarker,
    },
  ];
  if (size === 's') {
    contentStyle.push({padding: Sizes.s});
    titleStyle.push(TextStyles.textMediumS);
    descriptionStyle.push(TextStyles.textMediumXS);
  }
  return (
    <View style={props.containerStyle}>
      <Card borderColor={props.borderColor} backgroundColor={props.backgroundColor} testID={props.testID}>
        <View style={contentStyle}>
          {props.icon && <View style={styles.icon}>{props.icon}</View>}
          <View style={styles.textContainer}>
            {props.title && <Text style={titleStyle}>{props.title}</Text>}
            {props.body && <Text style={descriptionStyle}>{props.body}</Text>}
          </View>
        </View>
      </Card>
    </View>
  );
};

const styles = StyleSheet.create({
  content: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    padding: Sizes.m,
  },
  textContainer: {
    flex: 1,
    justifyContent: 'center',
    marginTop: 3,
  },
  icon: {marginRight: Sizes.m},
});
